import { required } from 'vuelidate/lib/validators';

const validations = {
  title: {
    required
  },
  description: {
    required
  },
  accountNumber: {
    required
  },
};

export default validations;